// extracted by mini-css-extract-plugin
export default {"dragPanel":"styles_dragPanel_QSzV7","left":"styles_left_QmXJb","right":"styles_right_AFqsL","center":"styles_center_ItEgJ"};